/* Copyright (c) 2020-present CloudIO Inc */

import { NormalizedAttributeType } from '@cloudio-saas/datasource-types';
import {
  CommonProps,
  defaultCommonProps,
} from '../../layout/Sidebar/panels/PropertiesView/CommonProperties';
import {
  BaseComponentItem,
  BooleanExpressionValue,
  ItemID,
} from '../../registry/Component.type';

export const attributeDataTypes = {
  Boolean: 'Boolean',
  Date: 'Date',
  JSON: 'JSON', // TODO
  Lookup: 'Lookup',
  Number: 'Number',
  Select: 'Select',
  TF: 'TF',
  Text: 'Text',
  YN: 'YN',
};

export const attributeBaseDataTypes = {
  Boolean: 'Boolean',
  Date: 'Date',
  DateTime: 'DateTime',
  StringDateTime: 'StringDateTime',
  JSON: 'JSON', // TODO
  Lookup: 'Lookup',
  Number: 'Number',
  Select: 'Select',
  TF: 'TF',
  Text: 'Text',
  YN: 'YN',
};

export const defaultOperators: Record<AttributeBaseDataType, string> = {
  Boolean: 'isTrue',
  Date: 'after',
  DateTime: 'after',
  StringDateTime: 'after',
  JSON: 'is', // TODO
  Lookup: 'is',
  Number: 'eq',
  Select: 'is',
  TF: 'is',
  Text: 'is',
  YN: 'is',
};

export type AttributeDataType = keyof typeof attributeDataTypes;
export type AttributeBaseDataType = keyof typeof attributeBaseDataTypes;

export function toAttributeDataType(
  normalizedAttributeType: NormalizedAttributeType,
): AttributeDataType {
  switch (normalizedAttributeType) {
    case 'String':
      return 'Text';
    default:
      return normalizedAttributeType;
  }
}

export type SmartSearchIdType = 'CanvasGrid' | 'DataGrid' | 'PivotTable';

export interface SmartSearch extends CommonProps {
  searchOnBlur?: boolean;
  enableSavedSearch?: boolean;
  showPublicView?: BooleanExpressionValue;
  queryOwnerPublicView?: boolean;
  idType?: SmartSearchIdType;
  gridId?: ItemID;
  pivotId?: ItemID;
  border?: 'full' | 'bottom' | 'none';
  roundedCorners?: boolean;
  sortSearchAttributes?: boolean;
  ignoreSpecialCharacters?: boolean;
  specialCharacters?: string;
}

export interface SmartSearchItem extends BaseComponentItem {
  props: SmartSearch;
  type: 'SmartSearch';
}

export const defaultValue: Required<SmartSearch> = {
  ...defaultCommonProps,
  searchOnBlur: false,
  enableSavedSearch: true,
  showPublicView: { value: false, type: 'boolean' },
  queryOwnerPublicView: false,
  idType: 'DataGrid',
  gridId: '',
  pivotId: '',
  border: 'full',
  roundedCorners: false,
  sortSearchAttributes: true,
  ignoreSpecialCharacters: false,
  specialCharacters: '',
};
